import { CplaceSingleTextControlChange, CplaceSingleTextControlParameters } from '../../api/model/models';
import { ControlChangeHandler } from '../../controls';
import { mockControlIdentity, mockControlStateSharedData } from './controls.shared';

export const mockCplaceSingleTextControlControlParams: CplaceSingleTextControlParameters = {
  componentName: 'CplaceSingleTextControlComponent',
  value: 'I am a value',
  isTextArea: false,
};

export const mockCplaceSingleTextControlControlState = {
  ...mockControlStateSharedData,
  identity: mockControlIdentity,
  controlParameters: mockCplaceSingleTextControlControlParams,
};

export const mockCplaceSingleTextControlChangeHandler: ControlChangeHandler<
  CplaceSingleTextControlChange,
  CplaceSingleTextControlParameters
> = (controlParameters, controlChange) => {
  return {
    ...controlParameters,
    value: controlChange.value,
  };
};
